module.exports = __webpack_public_path__ + "media/honey-icons/icon-thumb-up-69f70ab9.svg";